/*
  Making the star badge under the product title jump to the reviews.

  ---

  WHY THIS IS JAVASCRIPT AND NOT AN `href`.

  The review widget is an APP BLOCK in its own section, and the badge is a theme block in a
  different one, so the badge cannot see the review section's id at render time. That id is
  also generated — `shopify-section-template--<number>__judgeme_reviews` — and the number
  changes per template, so it cannot be hard-coded either.

  Deriving it from the badge's own `section.id` would work and was rejected: it would bake
  the review section's KEY into this block, and renaming that section in the theme editor
  would silently turn the link into a dead anchor with nothing to catch it.

  Depending on JavaScript costs nothing here, which is the part that settles it. The badge
  is drawn by Judge.me's script and renders NOTHING without it — so there is no scenario
  where a visitor can see this link but not run this file.

  ---

  The target is resolved at CLICK time, not on load. Judge.me renders the widget
  asynchronously, so anything resolved at load would race it. If nothing is found we leave
  the click alone rather than preventing it: a link that does nothing is better than one
  that jumps to the top of the page.
*/

(function () {
  if (window.__keepsetReviewLink) return;
  window.__keepsetReviewLink = true;

  var TARGET_ID = 'keepset-reviews';

  function reviews() {
    // The section wrapper first, so the jump lands above the widget's own heading with the
    // section's padding intact; the widget itself only as a fallback.
    return (
      document.querySelector('[id$="__judgeme_reviews"]') ||
      document.querySelector('.jdgm-review-widget') ||
      document.getElementById(TARGET_ID)
    );
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('[data-ks-reviews-link]');
    if (!link) return;

    var target = reviews();
    if (!target) return;

    event.preventDefault();

    // Give it the id the href points at, so the address bar and the back button behave the
    // way they would for an ordinary in-page link.
    if (!target.id) target.id = TARGET_ID;

    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });

    // Moving focus as well as the viewport, so a keyboard or screen-reader user actually
    // arrives rather than watching the page move without them. `tabindex="-1"` makes a
    // non-interactive section focusable without putting it in the tab order.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
